import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
let LinkMixin = class LinkMixin extends Vue {
  get isAppMaker() {
    return window.lowcode.__IS_APP_MAKER__;
  }
  get linkHref() {
    if (!this.href) return 'javascript:void(0)';
    let href = '';
    if (this.hrefType == 'url') {
      href = this.href;
    } else {
      const {
        hash,
        href: locationHref,
        origin
      } = window.location;
      const [appid, pid] = String(this.href).includes('/') ? String(this.href).split('/') : [];
      if (this.isAppMaker) {
        href = `${origin}/#/preview/${appid}/page/${pid}`;
      } else {
        const url = hash.includes('#') ? `#/page_${pid}` : `/page_${pid}`;
        href = locationHref.replace(hash, url);
      }
    }
    if (this.query.length > 0) {
      let query = '?';
      for (let i = 0; i < this.query.length; i++) {
        let key = this.query[i].label;
        let value = this.query[i].value;
        query += `${key}=${value}${i == this.query.length - 1 ? '' : '&'}`;
      }
      href += query;
    }
    return href;
  }
  get linkTarget() {
    return this.isAppMaker ? true : this.target;
  }
};
__decorate([Prop({
  default: 'primary'
})], LinkMixin.prototype, "type", void 0);
__decorate([Prop({
  default: true
})], LinkMixin.prototype, "underline", void 0);
__decorate([Prop({
  default: false
})], LinkMixin.prototype, "disabled", void 0);
__decorate([Prop({
  default: 'page'
})], LinkMixin.prototype, "hrefType", void 0);
__decorate([Prop({
  default: ''
})], LinkMixin.prototype, "href", void 0);
__decorate([Prop({
  default: false
})], LinkMixin.prototype, "target", void 0);
__decorate([Prop({
  default: () => []
})], LinkMixin.prototype, "query", void 0);
LinkMixin = __decorate([Component({
  name: 'LinkMixin'
})], LinkMixin);
export default LinkMixin;